module.exports = __webpack_public_path__ + "img/map_en_mobile.08a1b86.png";